import { render, staticRenderFns } from "./paypal-view.vue?vue&type=template&id=02fba63b&"
import script from "./paypal-view.vue?vue&type=script&lang=js&"
export * from "./paypal-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports